import { NavbarService } from "../services/navbar.service";
import { RouterModule } from "@angular/router";
import {inject, NgModule} from "@angular/core";
import {NuovaIstanzaComponent} from "./nuova-istanza/nuova-istanza.component";
import {IstanzeEmesseComponent} from "./istanze-emesse/istanze-emesse.component";
import {IntegrazioneComponent} from "./integrazione/integrazione.component";
import {PagamentoComponent} from "./pagamento/pagamento.component";
import {DettaglioIstanzaComponent} from "./dettaglio-istanza/dettaglio-istanza.component";
import {PagamentoTributiComponent} from "./pagamento-tributi/pagamento-tributi.component";
import {
  DettaglioPagamentoTributiComponent
} from "./pagamento-tributi/dettaglio-pagamento-tributi/dettaglio-pagamento-tributi.component";
import { PagamentoTerminatoComponent } from './pagamento-tributi/pagamento-terminato/pagamento-terminato.component';
import { InformativaPrivacyComponent } from './informativa-privacy/informativa-privacy.component';
import { RichiestaInviataComponent } from './richiesta-inviata/richiesta-inviata.component';
import { ListaPagamentiComponent } from './lista-pagamenti/lista-pagamenti.component';
import { IntegrazionePagamentiComponent } from './integrazione-pagamenti/integrazione-pagamenti.component';

const PrePath = 'Servizi/';

@NgModule({
  imports: [
    /* jhipster-needle-add-admin-module - JHipster will add admin modules here */
    RouterModule.forChild([
      {
        path: PrePath + 'consenso-privacy',
        component: InformativaPrivacyComponent,
      },
      {
        path: PrePath + 'NuovaIstanza',
        component: NuovaIstanzaComponent,
      },
      {
        path: PrePath + 'conferma-richiesta/:idIstanza',
        component: RichiestaInviataComponent,
      },
      {
        path: PrePath + 'DettaglioIstanza/:idIstanza',
        component: DettaglioIstanzaComponent,
      },
      {
        path: PrePath + 'IstanzeEmesse',
        component: IstanzeEmesseComponent,
      },
      {
        path: PrePath + 'integrazioneIstanza/:idIntegrazione',
        component: IntegrazioneComponent,
      },
      {
        path: PrePath + 'integrazionePagamenti/:idIstanza',
        component: IntegrazionePagamentiComponent,
      },
      {
        path: PrePath + 'Pagamento',
        component: PagamentoComponent,
      },
      {
        path: PrePath + 'Pagamento/:idPagamento',
        component: PagamentoComponent,
      },
      {
        path: PrePath + 'PagamentoIstanza',
        component: PagamentoComponent,
      },
      {
        path: PrePath + 'PagamentoTributi/:cdTributo',
        component: PagamentoTributiComponent,
      },
      {
        path: PrePath + 'PagamentoTributi/:cdTributo/:numero',
        component: PagamentoTributiComponent,
      },
      {
        path: PrePath + 'PagamentoTerminato/:numero',
        component: PagamentoTerminatoComponent,
      },
      {
        path: PrePath + 'ListaPagamenti',
        component: ListaPagamentiComponent
      }
    ]),
  ],
})
export class TributiRoutingModule {
}
